export default function requestGoogleOauthAccessToken(clientId) {
  return new Promise((resolve, reject) => {
    const tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
      callback(response) {
        if (response
          && response.access_token
        ) {
          resolve(response.access_token);
        } else {
          reject(new Error('GoogleClientError'));
        }
      },
      error_callback() {
        reject(new Error('GoogleClientError'));
      },
    });

    tokenClient.requestAccessToken();
  });
}
